import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import DataTable from "../../CommonComponents/common/datatable/DataTable";
import TabLayout from "../CommonTabLayout/TabLayout";
import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const DetailsPageLowerLayer = ({
  tabs = [],
  startAdornment,
  expandedRows,
  setExpandedRows,
  onTabChange,
  hideTabs = false
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (onTabChange)
      onTabChange(newValue);
  };

  const location = useLocation();

  useEffect(() => {
    setSelectedTab(0);
  }, [location.key]);

  const enhancedTabs = tabs.map((tab) => {
    const toolbar = tab.toolbar;
    const tabToolbarButtons = toolbar?.buttons || [];
    const tabToolbarIcons = toolbar?.icons || [];
    const tabToolbarSearch = toolbar?.search;
    const tabToolbarFilter = toolbar?.filter;

    return {
      ...tab,
      toolbarConfig: {
        buttons: tabToolbarButtons,
        icons: tabToolbarIcons,
        search: tabToolbarSearch,
        filter: tabToolbarFilter,
      },
      content: (
        <Box
          sx={{
            backgroundColor: tab.loading ? "#F2F3F4" : "#FFF",
            borderRadius: "5px",
            boxShadow:
              "0px 1px 2px 0px rgba(97, 24, 24, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
            fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif"`,
            fontSize: 11.5,
            fontWeight: "medium",
          }}
        >
          <Box display="flex" gap={1} flexWrap="nowrap" sx={{ mt: 0 }}>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              {tab.label?.startsWith("Items") && (
                <Box
                  sx={{
                    px: 2,
                    pt: 1,
                    pb: 1,
                    mb: 0,
                    borderLeft: "4px solid blueHighlight", // Blue accent border on left
                    backgroundColor: "#e0f7fa", // Very light blue background highlight
                    borderRadius: "4px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)", // subtle shadow
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      marginBottom: 0,
                      textAlign: "left",
                    }}
                  >
                    Item Summary
                  </Typography>
                </Box>
              )}
              {tab.loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', height: '30vh' }}>
                  <CircularProgress sx={{ color: "#7d7c7cff", mt: 3 }} />
                </Box>
              ) : tab.renderCustomContent ? (
                tab.renderCustomContent     // Render only the custom content if provided
              ) : (
                <DataTable
                  columns={tab.columns}
                  rows={tab.rows}
                  expandedRows={expandedRows}
                  setExpandedRows={setExpandedRows}
                  rowSelection="multiple"                         // allow multi-select
                  suppressRowClickSelection={true}                // clicking a row doesn't auto-select
                  onSelectionChanged={(params) => {
                    if (tab.onSelectionChanged) {
                      tab.onSelectionChanged(params);
                    }
                  }}
                />
              )}
              {/* {tab.renderCustomContent &&
                tab.renderCustomContent(tab.rows, expandedRows)} */}
            </Box>
            {tab.extraContent && (
              <Box sx={{ width: "100%", maxWidth: 400, minWidth: 320 }}>
                {tab.extraContent}
              </Box>
            )}
          </Box>
        </Box>
      ),
    };
  })

  return (
    <div
      className="container"
      style={{ marginTop: 15, marginBottom: 15, borderRadius: "5px" }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "5px",
          boxShadow:
            "0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif"`,
          fontSize: 11.5,
          fontWeight: "medium",
          overflow: "auto",
        }}
      >
        {/* ✅ CONDITIONALLY REMOVE TABLAYOUT */}
        {!hideTabs ? (
          <TabLayout
            tabs={enhancedTabs}
            currentTab={selectedTab}
            onTabChange={handleTabChange}
            startAdornment={startAdornment && startAdornment(selectedTab)}
            currentTabToolbarConfig={enhancedTabs[selectedTab]?.toolbarConfig}
          />
        ) : (
          <Box sx={{ px: 2, pt: 1 }}>
            {startAdornment && startAdornment(0)}
            {enhancedTabs[0]?.content}
          </Box>
        )}
      </Box>
    </div>
  );
};

export default DetailsPageLowerLayer;